import { render, staticRenderFns } from "./FoodCashier.vue?vue&type=template&id=3e3631b0&scoped=true&lang=pug&"
import script from "./FoodCashier.vue?vue&type=script&lang=ts&"
export * from "./FoodCashier.vue?vue&type=script&lang=ts&"
import style0 from "./FoodCashier.vue?vue&type=style&index=0&id=3e3631b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3631b0",
  null
  
)

export default component.exports